import { lazy, Suspense } from 'react'
import { Home } from './Home'

import { ServiceWorkerProvider } from './serviceWorker'
import { ThemeProvider } from 'mds-web-ui'
import { GlobalStyles } from './components/ui/Layout'
import ErrorBoundary from './ErrorBoundary'

import { init as initSentry } from './Sentry'

const ReduxProvider = lazy(() => import('./redux'))

initSentry()

export const App = () => (
  <ServiceWorkerProvider>
    <ThemeProvider>
      <GlobalStyles />
      <Suspense fallback={<div />}>
        <ReduxProvider>
          <ErrorBoundary>
            <Home />
          </ErrorBoundary>
        </ReduxProvider>
      </Suspense>
    </ThemeProvider>
  </ServiceWorkerProvider>
)
export default App
